export default {
    template: [
        'COMPANY_FOLLOW_TEMPLATE',
        data => ({
            id: data.companyId,
            followId: data.id,
            userId: data.userId,
        }),
    ],

    GET: {
        authorize: true,
    },

    POST: {
        authorize: true,
    },

    '/:id': {
        DELETE: {},
    },
};
